module.exports = __webpack_public_path__ + "static/media/studi1_logo.78fda77d.svg";